//This config will be used to configure event/action names for analytics purposes

const CATEGORIES = {
    AUTH:       'Auth',
    NAVIGATION: 'Navigation',
    TILE:       'Tile',
    REPORT:     'Report',
    SETTINGS:   'Settings',
    LOG:        'Log',
    ACTION:     'Action',
};

// Maps Redux tile ID → Amplitude display name (Title Case / correct acronyms)
const TILE_NAMES = {
    otb:               'OTB',
    pricing:           'Pricing',
    room_pricing:      'Room Pricing',
    pickup:            'Pickup',
    pace:              'Pace',
    compset:           'Compset',
    market:            'Market',
    market_sell_rates: 'Market Sell Rates',
    forecast:          'Forecast',
    budget:            'Budget',
    hotel_summary:     'Summary Report',
    market_summary:    'Market Summary',
    flights:           'Flights',
    group:             'Group IQ',
    price_calendar:    'Price Calendar',
    daily_flash:            'Daily Flash',
    events:                 'Events',
    bi_sensitivity_analysis:'Sensitivity Analysis',
    bi_pace_comparison:     'Pace Pickup 365',
    bi_pickup_analysis:     'OTB Multi Level',
    revpar_index:           'RevPAR Index',
    otb_v2_multi_segment:   'OTB Multi Level',
    restrictions:           'Restrictions',
    plr_logs:               'PLR Log',
    DailyRatesendStatus:    'Rate Push Log',
    rm_room_type_ratesend_status: 'Rate Push Log',
    restrictions_push_status:    'Restrictions Push Log',
};

// Tiles that are NOT category 'Tile' — only exceptions listed; everything else defaults to 'Tile'
const TILE_CATEGORIES = {
    market_summary:               CATEGORIES.REPORT,
    bi_sensitivity_analysis:      CATEGORIES.REPORT,
    bi_pace_comparison:           CATEGORIES.REPORT,
    bi_pickup_analysis:           CATEGORIES.REPORT,
    revpar_index:                 CATEGORIES.REPORT,
    otb_v2_multi_segment:         CATEGORIES.REPORT,
    plr_logs:                     CATEGORIES.LOG,
    DailyRatesendStatus:          CATEGORIES.LOG,
    rm_room_type_ratesend_status: CATEGORIES.LOG,
    restrictions_push_status:     CATEGORIES.LOG,
};

const analytics = {
    events: {
        // Auth
        logout:        { name: 'Logout',       category: CATEGORIES.AUTH },
        login_success: { name: 'Login Success', category: CATEGORIES.AUTH },
        login_fail:    { name: 'Login Failed',  category: CATEGORIES.AUTH },

        // Navigation
        tile_change:      { name: 'Tile Change',        category: CATEGORIES.TILE },
        tile_merged:      { name: 'Tile Intellimerged',  category: CATEGORIES.NAVIGATION },
        property_changed: { name: 'Property Changed',    category: CATEGORIES.NAVIGATION },
        ds_changed:       { name: 'Data Source Changed', category: CATEGORIES.NAVIGATION },
        day_date_change:  { name: 'Day Date Change',     category: CATEGORIES.NAVIGATION },
        stay_dates_changed: { name: 'Stay Dates Changed', category: CATEGORIES.NAVIGATION },

        // Reports
        flash_report_opened:           { name: 'Flash Report',           category: CATEGORIES.REPORT },
        sigma_analytics_report:        { name: 'Sigma Analytics',        category: CATEGORIES.REPORT },
        flight_sigma_analytics_report: { name: 'Flight Sigma Analytics', category: CATEGORIES.REPORT },
        market_legacy_report:          { name: 'Market Legacy Report',   category: CATEGORIES.REPORT },
        summary_report_change:         { name: 'Summary Report',         category: CATEGORIES.TILE },

        // Settings
        goto_property_settings:    { name: 'Property Settings',        category: CATEGORIES.SETTINGS },
        goto_profile_settings:     { name: 'Profile Settings',        category: CATEGORIES.SETTINGS },
        goto_scheduler_settings:   { name: 'Scheduler Settings',      category: CATEGORIES.SETTINGS },
        pricing_seasons_settings:  { name: 'Pricing Seasons Settings', category: CATEGORIES.SETTINGS },
        alerts_settings:           { name: 'Alerts Settings',         category: CATEGORIES.SETTINGS },
        report_scheduler_saved:    { name: 'Report Scheduler Saved',  category: CATEGORIES.ACTION },

        // Actions — rate & restriction push
        pricing_ratepush_success:       { name: 'Rate Push',                            category: CATEGORIES.ACTION },
        product_restriction_all_pushed:  { name: 'PLR Threshold Override', category: CATEGORIES.ACTION },
        product_restriction_date_pushed: { name: 'PLR Threshold Override', category: CATEGORIES.ACTION },

        // Actions — exports & reports
        export_download:      { name: 'Export Downloaded',    category: CATEGORIES.ACTION },
        report_downloaded:                      { name: 'Report Downloaded',              category: CATEGORIES.REPORT },
        pace_pickup_365_downloaded:             { name: 'Pace Pickup 365',                category: CATEGORIES.REPORT },
        segmented_market_summary_downloaded:    { name: 'Segmented Market Summary',       category: CATEGORIES.REPORT },
        kpi_property_summary_downloaded:        { name: 'KPI / Property Summary Report',  category: CATEGORIES.REPORT },
        report_download_failed: { name: 'Report Download Failed', category: CATEGORIES.REPORT },

        // Actions — data level
        change_data_level:              { name: 'Change Data Level',                        category: CATEGORIES.ACTION },
        pricing_hotel_data_level:       { name: 'Pricing', category: CATEGORIES.TILE },
        pricing_rt_data_level:          { name: 'Pricing', category: CATEGORIES.TILE },
        restriction_hotel_data_level:   { name: 'Restriction Data Level Changed To Hotel',  category: CATEGORIES.ACTION },
        restriction_rt_data_level:      { name: 'Restriction Data Level Changed To Room Type', category: CATEGORIES.ACTION },
        restriction_product_data_level: { name: 'Restriction Data Level Changed To Product', category: CATEGORIES.ACTION },

        // Actions — PLR
        plr_details_open:               { name: 'PLR Details Open',             category: CATEGORIES.ACTION },
        plr_threshold_override:         { name: 'PLR Threshold Override',       category: CATEGORIES.ACTION },
        PLR_restriction_push_failed:    { name: 'PLR Restriction Push Failed',  category: CATEGORIES.ACTION },
        plr_threshold_override_failed:  { name: 'PLR Threshold Override Failed',  category: CATEGORIES.ACTION },
        plr_threshold_override_success: { name: 'PLR Threshold Override Success', category: CATEGORIES.ACTION },

        // Actions — notes & events
        note_opened:        { name: 'Note Opened',       category: CATEGORIES.ACTION },
        note_saved:         { name: 'Sticky Note Saved', category: CATEGORIES.ACTION },
        view_event:         { name: 'View Event',        category: CATEGORIES.ACTION },
        add_event:          { name: 'Add Event',         category: CATEGORIES.ACTION },
        edit_event:         { name: 'Edit Event',        category: CATEGORIES.ACTION },
        delete_event:       { name: 'Delete Event',      category: CATEGORIES.ACTION },
        bulk_events_upload: { name: 'File Uploaded',     category: CATEGORIES.ACTION },

        // Actions — GroupIQ
        groupIQ:                  { name: 'Group IQ Open',                   category: CATEGORIES.ACTION },
        groupIQ_submit_quote:     { name: 'Group IQ Submit Quote',           category: CATEGORIES.ACTION },
        groupIQ_save_quote:       { name: 'Group IQ Save Quote',             category: CATEGORIES.ACTION },
        groupIQ_custom_tab:       { name: 'Group IQ Custom Tab Open',        category: CATEGORIES.ACTION },
        groupIQ_custom_tab_input: { name: 'Group IQ Custom Tab Input Changed', category: CATEGORIES.ACTION },

        // Actions — popups & notifications
        notification_popup_open:    { name: 'Notification Popup Open',    category: CATEGORIES.ACTION },
        notification_popup_closed:  { name: 'Notification Popup Closed',  category: CATEGORIES.ACTION },
        group_pricing_popup_opened: { name: 'Group Pricing Popup Opened', category: CATEGORIES.ACTION },
        announcement_popup_open:    { name: 'Announcement Popup Open',    category: CATEGORIES.ACTION },
        announcement_popup_closed:  { name: 'Announcement Popup Closed',  category: CATEGORIES.ACTION },
        announcement_notshowagain:  { name: 'Not Show Again Enabled',     category: CATEGORIES.ACTION },
        announcement_tour_clicked:  { name: 'Announcement Tour Clicked',  category: CATEGORIES.ACTION },
    },

    tiles: TILE_NAMES,

    axns: {},
};

export { CATEGORIES, TILE_NAMES, TILE_CATEGORIES };
export default analytics;
